<!--
* UI Name: Workflow Group List
* PIC: 213960
* Modify Date: 2022/10/15
-->
<template>
  <div class="container process-list-container">
    <!-- Header -->
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{
          $t('lbl.workflowGroup.pageHeader')
        }}</v-toolbar-title>
      </v-col>
    </v-row>
    <!-- /**
     * 2021.07.27 203737 SPKA-167 issue 110 Change all text field and combo box style for search condition [Process Setup]
     */ -->
    <v-row class="custom-form-control custom-form-control-type-2 custom-figma-1 mb-0">
      <v-col cols="12" class="search-conditions-display">
        <div class="pl-0 pt-0 pb-0 collapse-search-conditions hide">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('collapse')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-up</v-icon>
            {{ $t('btn.common.collapseConditions') }}
          </v-btn>
        </div>
        <div class="pl-0 pt-0 pb-0 expand-search-conditions">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('expand')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-down</v-icon>
            {{ $t('btn.common.expandConditions') }}
          </v-btn>
        </div>
      </v-col>
      <v-col class="pb-0 pt-0" cols="12">
        <v-row>
          <v-col
            class="comm-header-col data-query-section custom-field-combo custom-figma-1 pb-0 pt-0 mt-0"
            cols="12"
            lg="11"
            md="10"
          >
            <v-row>
              <v-col class="pb-0 pt-0 mb-0 arrow-btn-custom" cols="2" lg="2" md="2">
                <v-text-field
                  v-model="srcProcNm"
                  :label="$t('lbl.common.conditionSearch.findbyName')"
                  @keyup.enter="searchList()"
                  dense
                  filled
                  class="pl-0 find-by-name-workflow"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-0" cols="2" lg="2" md="2">
                <div class="pl-0 pt-0 pb-0">
                  <v-autocomplete
                    v-model="srcComponentType"
                    :menu-props="{ offsetY: true }"
                    :items="compTypeList"
                    :label="$t('lbl.common.conditionSearch.componentType')"
                    @keyup.enter="searchList()"
                    @change="searchList()"
                    dense
                    filled
                  ></v-autocomplete>
                </div>
              </v-col>
              <v-col class="pb-0 pt-0 pr-0" cols="2" lg="2" md="2">
                <div class="pl-0 pt-0 pb-0">
                  <v-text-field
                    v-model="srcComponentName"
                    :label="$t('lbl.common.conditionSearch.componentName')"
                    @keyup.enter="searchList()"
                    dense
                    filled
                  ></v-text-field>
                </div>
              </v-col>
              <v-col v-if="!srcComponentType" class="pb-0 pt-0 pr-0" cols="2" lg="2" md="2">
                <div class="pl-0 pt-0 pb-0">
                  <v-autocomplete
                    :disabled="!srcComponentType"
                    :menu-props="{ offsetY: true }"
                    :items="comTypeList"
                    :label="$t('lbl.common.conditionSearch.type')"
                    dense
                    filled
                  ></v-autocomplete>
                </div>
              </v-col>
              <v-col v-if="srcComponentType === 'COM'" class="pb-0 pt-0" cols="2" lg="2" md="2">
                <div class="pl-0 pt-0 pb-0">
                  <v-autocomplete
                    v-model="srcCommunicationType"
                    :menu-props="{ offsetY: true }"
                    :items="comTypeList"
                    :label="$t('lbl.common.conditionSearch.communicationType')"
                    @keyup.enter="searchList()"
                    @change="searchList()"
                    dense
                    filled
                  ></v-autocomplete>
                </div>
              </v-col>
              <v-col v-if="srcComponentType === 'CVT'" class="pb-0 pt-0" cols="2" lg="2" md="2">
                <div class="pl-0 pt-0 pb-0">
                  <v-autocomplete
                    v-model="srcConverterType"
                    :menu-props="{ offsetY: true }"
                    :items="getCvtTypeList"
                    :label="$t('lbl.common.conditionSearch.converterType')"
                    @keyup.enter="searchList()"
                    @change="searchList()"
                    dense
                    filled
                  ></v-autocomplete>
                </div>
              </v-col>
              <v-col v-if="srcComponentType === 'AI'" class="pb-0 pt-0" cols="2" lg="2" md="2">
                <div class="pl-0 pt-0 pb-0">
                  <v-autocomplete
                    v-model="srcAIType"
                    :menu-props="{ offsetY: true }"
                    :items="aiTpCdList"
                    :label="$t('lbl.common.conditionSearch.communicationType')"
                    @keyup.enter="searchList()"
                    @change="searchList()"
                    dense
                    filled
                  ></v-autocomplete>
                </div>
              </v-col>
              <v-col v-if="srcComponentType === 'FLT'" class="pb-0 pt-0" cols="2" lg="2" md="2">
                <div class="pl-0 pt-0 pb-0">
                  <v-autocomplete
                    v-model="srcFilterType"
                    :menu-props="{ offsetY: true }"
                    :items="getFltTypeList"
                    :label="$t('lbl.common.conditionSearch.filterType')"
                    @keyup.enter="searchList()"
                    @change="searchList()"
                    dense
                    filled
                  ></v-autocomplete>
                </div>
              </v-col>
              <v-col class="pb-0 pt-0 mt-0" cols="4" lg="4" md="4">
                <div v-if="!srcComponentType" class="pl-0 pt-0 pb-0">
                  <v-text-field
                    :disabled="!srcComponentType"
                    :label="$t('lbl.common.conditionSearch.additionalInformation')"
                    dense
                    filled
                  ></v-text-field>
                </div>
                <div v-if="srcComponentType === 'COM'" class="pl-0 pt-0 pb-0">
                  <v-text-field
                    v-model="srcCommunicationEndPoint"
                    :label="$t('lbl.common.conditionSearch.connectorEndPoint')"
                    @keyup.enter="searchList()"
                    dense
                    filled
                  ></v-text-field>
                </div>
                <div v-if="srcComponentType === 'CVT'" class="pl-0 pt-0 pb-0">
                  <v-text-field
                    v-model="srcConverterPattern"
                    :label="$t('lbl.common.conditionSearch.converterPattern')"
                    @keyup.enter="searchList()"
                    dense
                    filled
                  ></v-text-field>
                </div>
                <div v-if="srcComponentType === 'AI'" class="pl-0 pt-0 pb-0">
                  <v-text-field
                    v-model="srcAIEndPoint"
                    :label="$t('lbl.common.conditionSearch.aiEndPoint')"
                    @keyup.enter="searchList()"
                    dense
                    filled
                  ></v-text-field>
                </div>
                <div v-if="srcComponentType === 'FLT'" class="pl-0 pt-0 pb-0">
                  <v-text-field
                    v-model="srcFilterPattern"
                    :label="$t('lbl.common.conditionSearch.filterPattern')"
                    @keyup.enter="searchList()"
                    dense
                    filled
                  ></v-text-field>
                </div>
              </v-col>
              <v-col
                v-show="$cookies.get('user-admin-yn') !== 'Y'"
                class="pb-0 pt-0"
                cols="2"
                lg="2"
                md="2"
              >
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="comm-header-col date-query-section pb-0 mt-0 pr-0 custom-figma-1 pt-0 text-right"
            cols="12"
            lg="1"
            md="2"
          >
            <div class="pl-0 pt-0 pb-0 btn-control mr-3">
              <v-btn
                class="btn-width-1 btn btn-top btn-search"
                color="primary"
                @click.native="search"
                :disabled="!$auth.search"
              >
                <v-icon x-small class="mr-2">fa fa-search</v-icon>{{ $t('btn.common.search') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Grid table page class="flat-file-control-section" -->
    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg">
        <v-row>
          <v-col lg="5" md="5">
            <v-row>
              <v-col class="page-control-bg" cols="12">
                <v-btn
                  @click.native="openProcessWindow('', 'Add')"
                  :disabled="!$auth.manage"
                  class="btn btn-add"
                >
                  {{ $t('btn.common.add') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="3" md="2" class="d-inline-flex"></v-col>
          <v-col lg="4" md="5" class="filter-search">
            <v-row>
              <v-col class="mr-0 pr-0" md="5">
                <v-select
                  v-model="searchBy"
                  :items="searchByItems"
                  :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                  class="search-by data-table-select-box custom-selectbox flat-file-selectbox custom-pagination-figma-v3-filter-area mr-0"
                  height="30"
                  hide-details
                  dense
                  solo
                ></v-select>
              </v-col>
              <v-col class="ml-0 pl-0" cols="12" md="7">
                <v-text-field
                  v-model="searchByTxt"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  class="data-table-filter-text-field search-button-data-analysis-table flat-file custom-pagination-figma-v3-filter-area"
                  heigth="30"
                  append-icon="fa fa-search"
                  hide-details
                  dense
                  solo
                  @input="onFilterProcessList"
                  @click:append="onFilterProcessList"
                  v-on:keyup.enter="onFilterProcessList"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <!-- // 203737 05/10/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu -->
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0 pb-0">
        <v-table
          ref="process_list_table"
          :height="tableHeight"
          :title-rows="titleRows"
          :columns="$cookies.get('user-admin-yn') === 'Y' ? columns : columnsNotCompay"
          :table-data="getListData"
          :title-row-height="$vuetify.theme.dark ? 45 : 41"
          :row-height="35"
          :class="
            $vuetify.theme.dark
              ? 'v-search-list-table-merge srm-list-table repo-list-table custom-figma-1'
              : 'v-search-list-table-merge srm-list-table repo-list-table border-top'
          "
          :errorContent="'No matching records found'"
          :border-header-height="$vuetify.theme.dark ? 0 : 4"
          is-horizontal-resize
          is-vertical-resize
          width="100%"
          :paging-index="(page - 1) * itemsPerPage"
          :multiple-sort="false"
          @sort-change="sortChange"
          @click-overlay="closeTbOverlay"
          :row-click="rowClick"
          :row-mouse-enter="rowEnter"
          :row-mouse-leave="rowLeave"
          :show-horizontal-border="$vuetify.theme.dark ? true : false"
        >
          <template v-slot:index="{ item }">
            <div class="index-col">{{ setIndex(item.id) }}</div>
          </template>
          <template v-slot:procNm="{ item }">
            <font class="pl-2 col-name">{{ item.procNm }}</font>
          </template>
          <template v-slot:compNm="{ item }">
            <font class="pl-2">{{ item.compNm }}</font>
          </template>
          <template v-slot:routePath="{ item }">
            <div v-if="!$auth.manage">View</div>
            <a v-else class="link-file-text" @click="openMiniView(item)">View</a>
          </template>
          <template v-slot:mng="{ item }">
            <!-- // 2021.12.1 SPKA-297 svg icon -->
            <v-btn small text icon @click="checkOpenDetail(item, 'Edit')" :disabled="!$auth.manage">
              <icon-svg :disabled="!$auth.manage" iconName="edit" />
            </v-btn>
            <v-btn small text icon @click="openViewProcess(item)" :disabled="!$auth.manage">
              <icon-svg iconName="view" :disabled="!$auth.manage" />
            </v-btn>
            <v-btn
              @click="openProcessWindow(item, 'Copy')"
              :disabled="!$auth.manage"
              small
              text
              icon
            >
              <icon-svg :disabled="!$auth.manage" iconName="copy" />
            </v-btn>
            <v-btn
              @click="checkBeforeDetele(item, 'Delete')"
              :disabled="!$auth.manage"
              small
              text
              icon
            >
              <icon-svg :disabled="!$auth.manage" iconName="delete" />
            </v-btn>
            <v-btn
              v-if="item.lock"
              @click="unlockWF(item)"
              :disabled="
                ($cookies.get('user-id') !== item.lock || $cookies.get('user-admin-yn') !== 'Y') &&
                  $cookies.get('use-grade') !== '3' &&
                  $cookies.get('use-grade') !== '9'
              "
              small
              text
              icon
            >
              <icon-svg
                :disabled="
                  ($cookies.get('user-id') !== item.lock ||
                    $cookies.get('user-admin-yn') !== 'Y') &&
                    $cookies.get('use-grade') !== '3' &&
                    $cookies.get('use-grade') !== '9'
                "
                iconName="lock"
              />
            </v-btn>
            <v-btn v-else disabled small text icon>
              <icon-svg iconName="unlock" :disabled="true" />
            </v-btn>
          </template>
          <!-- 2021.9.17 203728 Verson is Initial => not send JSON (Save) => can't send JSON -->
          <template v-slot:version="{ item }">
            <div v-if="!$auth.manage && item.version">{{ item.version }}</div>
            <a v-else-if="item.version" class="link-file-text" @click="getPartnerList(item)">{{
              item.version
            }}</a>
            <font v-else>Initial</font>
          </template>
        </v-table>
      </v-col>
      <v-overlay
        :absolute="absolute"
        :value="overlay"
        :dark="$vuetify.theme.dark"
        class="tableOverlay"
      >
        <v-data-table
          :items="listSrm"
          :hide-default-footer="true"
          :disable-sort="true"
          :hide-default-header="true"
          class="overlay-table"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id" @click.stop="closeTbOverlay">
                <td class="sender-col">{{ item }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-overlay>
    </v-row>
    <v-row v-show="totalCnt > 0" class="custom-pagination-figma-v3-last">
      <v-col class="page-control-content page-control-bg transaction-pagi custom-paging-row">
        <v-row>
          <v-col lg="12" md="12">
            <v-row>
              <v-col class="page-control-bg text-left pa-0" cols="6">
                <div class="custom-pagi-selectbox custom-pagination-figma-v3-selectbox">
                  <v-select
                    @change="changePageSize"
                    v-model="itemsPerPage"
                    hide-details
                    dense
                    solo
                    :items="rowPerPage"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox"
                  >
                  </v-select>
                </div>
                <div class="page-showing">
                  <v-label>
                    {{ itemsPerPage * (page - 1) + 1 }} ~
                    {{ itemsPerPage * (page - 1) + listData.length }} of {{ totalCnt }}
                  </v-label>
                </div>
              </v-col>
              <v-col class="page-control-bg text-right pa-0" cols="6">
                <!-- 2021.11.23 203728 SPKA-260 first prev button -->
                <button
                  type="button"
                  @click="changePage(1)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == 1 ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-sm fa-step-backward"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="changePageByTextbox(-1)"
                  :class="[
                    'mr-3 custom-btn-first-last-paging',
                    page - 1 < 1 ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-left"></i></span>
                  </div>
                </button>
                <!-- 2021.11.23 203728 SPKA-260 hidden input page number -->
                <v-text-field
                  v-model="pageEnter"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field custom-pagi-selectbox page-selectbox custom-pagination-figma-v3-text-box"
                  @keyup.enter="changePageByTextbox(0)"
                ></v-text-field
                ><label class="custom-pagination-figma-v3-label">/ {{ pageCount }}</label>
                <!-- 2021.11.23 203728 SPKA-260 hidden next last button -->
                <button
                  type="button"
                  @click="changePageByTextbox(1)"
                  :class="[
                    'ml-3 custom-btn-first-last-paging',
                    page + 1 > pageCount ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-right"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="changePage(pageCount)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == pageCount ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-sm fa-step-forward"></i></span>
                  </div>
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <miniView
        v-if="dialog.type == 'miniView'"
        class="maplist-layout-dialog"
        :removeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :id="dialog.id"
      ></miniView>
    </div>
    <dialogWindow
      ref="ActivatedSuccess"
      size="max"
      :detail="$t('msg.common.success.detail', ['Workflow', 'activated'])"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="DeactivatedSuccess"
      size="max"
      :detail="$t('msg.common.success.detail', ['Workflow', 'deactivated'])"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="AlertProcessSetup"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="searchList"
    ></dialogWindow>
    <dialogWindow ref="AlertLockWF" size="max" :detail="alertMessage" color="warning">
    </dialogWindow>
    <dialogWindow
      ref="DeleteWorkflow"
      :info="deleteItem.procNm"
      :detail="$t('msg.common.infoConfirm.detail', ['delete the workflow'])"
      :showCancel="true"
      @select-ok="
        deleteProcess(deleteItem.id, deleteItem.procId, deleteItem.compId, deleteItem.version)
      "
      color="confirmation"
      title="Process Setup Remove"
      size="max"
    ></dialogWindow>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { mapState } from 'vuex';
import $ from 'jquery';
import { resizeTableHeight } from '@/vue-dlb/common/common';
import miniView from '@/vue-caas/views/workflowgroup/MiniView.vue';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import { getIndexItem } from '@/vue-dlb/common/common';
// 2021.12.1 SPKA-297 svg icon
import IconSvg from '@/vue-caas/components/IconBase.vue';
import { setProcessWindowList, deleteProcessWindow } from '@/vue-caas/utils/process';
import { openWindow } from '@/vue-dlb/utils/window-opener';

export default {
  components: {
    dialogWindow,
    miniView,
    SystemProgress,
    IconSvg, // 2021.12.1 SPKA-297 svg icon
  },

  data() {
    return {
      srcComponentType: null,
      srcComponentName: '',
      srcCommunicationType: null,
      srcConverterType: null,
      srcAIType: null,
      srcFilterType: null,
      // 2021.8.30 203728 SPKA-201 add end point condition
      srcCommunicationEndPoint: '',
      srcAIEndPoint: '',
      srcConverterPattern: '',
      srcFilterPattern: '',
      comTypeList: [
        { text: this.$t('lbl.common.conditionSearch.all'), value: '' },
        { text: 'FTP', value: 'FTP' },
        { text: 'FTP(S)', value: 'FTPS' },
        { text: 'SFTP', value: 'SFTP' },
        { text: 'SMTP', value: 'SMTP' },
        { text: 'POP3', value: 'POP3' },
        { text: 'IMAP', value: 'IMAP' },
        { text: 'REST API', value: 'API' },
        { text: 'IBM MQ', value: 'IBM_MQ' },
        { text: 'Active MQ', value: 'ACTIVE_MQ' },
        { text: 'SOAP', value: 'SOAP' },
        { text: 'HTTP', value: 'HTTP' },
      ],
      cvtTypeList: [],
      fltTypeList: [],
      compTypeList: [
        { value: '', text: this.$t('lbl.common.conditionSearch.all') },
        { value: 'COM', text: 'Connector' },
        { value: 'CVT', text: 'Converter' },
        { value: 'FLT', text: 'Filter' },
        { value: 'DIR', text: 'Folder' },
        { value: 'USR', text: 'User Component' },
        { value: 'AI', text: 'AI Client' },
      ],
      tableHeight: 635,
      isCreated: false,
      compOrgList: [],
      /* 2020/11/06 203737 Remove unused source
        partner:'',
        messageDirecion:'',*/
      isFilter: false,
      message: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 50,
      srcProcNm: '',
      srcPrnrId: null,
      srcCompId: null,
      srcSendId: '',
      srcRecvId: '',
      srcMsgId: null,
      srcProcDirCd: null,
      searchBy: 'all',
      searchByTxt: '',
      pageEnter: 1,
      listData: [],
      prnrList: [{ text: 'Select Partner', value: '' }],
      compList: [{ text: 'Select Company', value: '' }],
      EDIMesList: [{ text: 'Select Message', value: '' }],
      rowPerPage: [
        { value: 10, text: 'Show 10' },
        { value: 25, text: 'Show 25' },
        { value: 50, text: 'Show 50' },
        { value: 75, text: 'Show 75' },
        { value: 100, text: 'Show 100' },
      ],
      arrLayoutDialog: [],
      dialogs: [],
      dialogId: 1,
      searchByItems: [
        { text: this.$t('lbl.common.searchTypePlaceHolder'), value: 'all' },
        { text: 'Name', value: 'procNm' },
        // { text: 'Partner', value: 'pnnrNm' },
        // { text: 'Sender', value: 'sendId' },
        // { text: 'Receiver', value: 'recvId' },
        { text: 'Message', value: 'msgNm' },
        // { text: 'Direction', value: 'procDirNm' },
        { text: 'Process Path', value: 'routePath' },
        { text: 'Last Run', value: 'updDt' },
        { text: 'Last Update', value: 'updDt' },
        { text: 'Manage', value: 'mng' },
        // { text: 'Activation', value: 'actCd'},
      ],
      masterSearchItems: {
        header: ['ADMIN_YN', 'CUST_ID'],
        data: [
          {
            ADMIN_YN: '',
            CUST_ID: '',
          },
        ],
      },
      messageList: [],
      checkDialogColor: 'success',
      checkDialogInfo: '',
      boundList: [],
      mapItem: [],
      prnrMap: {},
      absolute: false,
      overlay: false,
      listSrm: [],
      isLoading: true,
      titleRows: [
        [
          {
            fields: ['index'],
            title: this.$t('tbl.common.columnNo'),
            titleAlign: 'center',
          },
          {
            fields: ['procNm'],
            title: 'Name',
            titleAlign: 'center',
            newprop: 'newprop',
            orderBy: '',
            titleCellClassName: 'procNm',
          },
          {
            fields: ['compNm'],
            title: 'Company',
            titleAlign: 'center',
            newprop: 'newprop',
            orderBy: '',
            titleCellClassName: 'compId',
          },
          { fields: ['version'], title: 'Version', titleAlign: 'center', orderBy: '' },
          { fields: ['mng'], title: 'Manage', titleAlign: 'center' },
          { fields: ['routePath'], title: 'Process Path', titleAlign: 'center' },
          {
            fields: ['updDt'],
            title: 'Last Update',
            titleAlign: 'center',
            orderBy: 'desc',
          },
          { fields: ['updUsrId'], title: 'Update User', titleAlign: 'center' },
        ],
      ],
      columns: [
        { field: 'index', width: 30, customSlot: true, columnAlign: 'center', isFrozen: true },
        {
          field: 'procNm',
          width: 400,
          customSlot: true,
          className: 'frozen-col-bg',
          columnAlign: 'left',
          isFrozen: true,
        },
        { field: 'compNm', width: 150, customSlot: true, columnAlign: 'left', isResize: true },
        { field: 'version', width: 120, columnAlign: 'center', customSlot: true },
        { field: 'mng', width: 150, customSlot: true, columnAlign: 'center' },
        { field: 'routePath', width: 120, customSlot: true, columnAlign: 'center' },
        { field: 'updDt', width: 150, columnAlign: 'center', isResize: true },
        { field: 'updUsrId', width: 150, columnAlign: 'center', isResize: true },
      ],
      columnsNotCompay: [
        { field: 'index', width: 30, customSlot: true, columnAlign: 'center', isFrozen: true },
        {
          field: 'procNm',
          width: 400,
          customSlot: true,
          className: 'frozen-col-bg',
          columnAlign: 'left',
          isFrozen: true,
        },
        { field: 'version', width: 120, columnAlign: 'center', customSlot: true },
        { field: 'mng', width: 150, customSlot: true, columnAlign: 'center' },
        { field: 'routePath', width: 120, customSlot: true, columnAlign: 'center', isResize: true },
        { field: 'updDt', width: 150, columnAlign: 'center' },
        { field: 'updUsrId', width: 150, columnAlign: 'center' },
      ],
      totalCnt: 0,
      listDataOrigin: [],
      // 2021.9.9 203728 SPKA-199 Change background when hover,click row in v-table
      rowCurrentClick: -1,
      rowKey: '',
      listFrozen: ['index', 'procNm', 'compNm', 'version', 'mng', 'routePath', 'updDt', 'updUsrId'],
      // srcProcTestOrLive: 'T',
      activationList: [
        { text: this.$t('lbl.common.conditionSearch.all'), value: '' },
        { text: 'Active', value: 'Y' },
        { text: 'Inactive', value: 'N' },
      ],
      srcProcActCd: null,
      fltrTpCdList: [],
      cvtrTpCdList: [],
      protocolList: [],
      // 2021.11.8 203728 SPKA-243 check lock/unlock
      alertMessage: '',
      deleteItem: {},
    };
  },

  computed: {
    getPrnrList() {
      return this.prnrList;
    },
    getCompList() {
      return this.compList;
    },
    getCvtTypeList() {
      this.cvtTypeList = [{ text: this.$t('lbl.common.conditionSearch.all'), value: '' }];
      for (let i = 0; i < this.cvtrTpCdList.length; i++) {
        this.cvtTypeList.push(this.cvtrTpCdList[i]);
      }
      return this.cvtTypeList;
    },
    getFltTypeList() {
      this.fltTypeList = [{ text: this.$t('lbl.common.conditionSearch.all'), value: '' }];
      for (let i = 0; i < this.fltrTpCdList.length; i++) {
        this.fltTypeList.push(this.fltrTpCdList[i]);
      }
      return this.fltTypeList;
    },
    getListData() {
      let compList = this.compList;
      let comp = [];
      let compNm = '';
      this.listData.map((processItem) => {
        comp = compList.filter((compItem) => compItem.value === processItem.compId);
        // 2021.10.20 203728 SPKA-224 if * show * not ''
        compNm = comp[0] ? comp[0].text : processItem.compId === '*' ? '*' : '';
        processItem['compNm'] = compNm;
      });
      return this.listData;
    },
    ...mapState('common', {
      CommMsgList: 'CommMsgList',
      sysloadingTitle: 'sysloadingTitle',
    }),
    ...mapState('map', {
      mapList: 'mapListSMLK',
    }),
  },

  watch: {
    itemsPerPage() {
      this.caculatePageCount();
      if (this.page > this.pageCount) {
        this.page = this.pageCount;
      }
      this.changePage(this.page, false);
    },
    page() {
      this.pageEnter = this.page;
    },
    listData() {
      return this.listData;
    },
  },
  beforeUpdate() {},
  async created() {
    this.boundList = [
      { text: this.$t('lbl.common.conditionSearch.all'), value: '' },
      { text: 'Inbound', value: 'I' },
      { text: 'Outbound', value: 'O' },
    ];
    /*  05/17/2021 203737 SPKA-108 issue 60 Modify to display the company combo in search condition and company column in search result
          when only comp_info.sp_flag = 'Y' */
    if ($cookies.get('user-admin-yn') === 'Y') {
      this.headers = this.headersCompany;
    } else {
      this.headers = this.headersNotCompany;
    }

    // 2021.10.20 203728 call some common list
    this.$store.dispatch('caascommon/getComCdList', { grpCd: 'P05' }).then(() => {
      this.fltrTpCdList = this.$store.getters['caascommon/comCdList'];
    });

    this.$store.dispatch('caascommon/getComCdList', { grpCd: 'P06' }).then(() => {
      this.cvtrTpCdList = this.$store.getters['caascommon/comCdList'];
    });

    this.$store.dispatch('caascommon/getComCdList', { grpCd: 'P09' }).then(() => {
      let list = this.$store.getters['caascommon/comCdList'];
      list.map((item) => {
        this.protocolList.push({ text: item.text, value: item.value });
      });
    });

    this.$store.dispatch('caascommon/getComCdList', { grpCd: 'P17' }).then(() => {
      this.aiTpCdList = this.$store.getters['caascommon/comCdList'];
    });

    this.getMapList();

    this.compList = [{ text: this.$t('lbl.common.conditionSearch.all'), value: '' }];
    await this.$store.dispatch('getCompanyListSetup').then(() => {
      const tmpCompList = this.$store.getters.companiesForSetup;
      for (let i = 0; i < tmpCompList.length; i += 1) {
        const tmpComp = tmpCompList[i];
        const tmp = { text: tmpComp.compNm, value: tmpComp.compId };
        this.compList.push(tmp);
      }
    });
    this.getEDIMsgTypeList();
    this.searchList();
    this.isCreated = true;
  },
  methods: {
    displaySearchConditions(action) {
      if (action === 'expand') {
        $('.date-query-section').css('display', 'block');
        $('.data-query-section').css('display', 'block');
        $('.expand-search-conditions').css('display', 'none');
        $('.collapse-search-conditions').css('display', 'block');
      } else {
        $('.date-query-section').css('display', 'none');
        $('.data-query-section').css('display', 'none');
        $('.expand-search-conditions').css('display', 'block');
        $('.collapse-search-conditions').css('display', 'none');
      }
    },
    viewFileMoveDBMapBuilder(item) {
      const type = 'DBMapBuilder';
      const params = {
        ROWID: item.xml_id,
        type: type,
        options: {
          dataValue: item,
          id: item.xml_id,
        },
      };
      item.id = item.xml_id;
      const arrView = {
        item,
        type,
      };
      const url = `/process/dbadapter/dbmapbuilder?dbMapperId=${item.xml_id}`;
      openWindow({
        arrView,
        url: url,
        params,
      });
    },
    // 2021.10.20 203728 SPKA-224 get map list
    getMapList() {
      const masterSearchItems = {
        header: ['ADMIN_YN', 'CUST_ID'],
        data: [
          {
            ADMIN_YN: this.$cookies.get('user-admin-yn'),
            CUST_ID: this.$cookies.get('comp-id'),
          },
        ],
      };
      this.mapItem = [{ text: this.$t('lbl.common.conditionSearch.all'), value: '' }];
      Store.dispatch('map/queryMapListByProcSetup', masterSearchItems).then(() => {
        for (let i = 0; i < this.mapList.length; i++) {
          let mapObj = {};
          mapObj.text = `${this.mapList[i].MESSAGENAME}-(${this.mapList[i].MAPPINGNAME})`;
          mapObj.value = this.mapList[i].MAP_PRCS_NO;
          if (this.mapItem.indexOf(mapObj) === -1) {
            this.mapItem.push(mapObj);
          }
        }
        this.messageList = this.mapList;
      });
    },
    // 2021.9.89 203728 SPKA-199 Change background when hover,click row in v-table
    rowClick(rowIndex, rowData) {
      this.listFrozen.map((e) => {
        $('.v-table-rightview .v-table-row').removeClass('custom-row-click-v-table');
        $('.v-table-rightview .v-table-row:eq(' + rowIndex + ')').addClass(
          'custom-row-click-v-table',
        );
        $('#' + e + this.rowCurrentClick).removeClass('custom-row-click-v-table');
        $('#' + e + rowIndex).addClass('custom-row-click-v-table');
      });
      this.rowCurrentClick = rowIndex;
      this.rowKey = rowData.procId;
    },
    rowEnter(rowIndex) {
      this.listFrozen.map((e) => {
        $('#' + e + rowIndex).addClass('custom-row-click-v-table');
      });
    },
    rowLeave(rowIndex) {
      if (this.rowCurrentClick !== rowIndex) {
        this.listFrozen.map((e) => {
          $('#' + e + rowIndex).removeClass('custom-row-click-v-table');
        });
      }
    },
    // 2022.06.17 213960 Get partner list
    getPartnerList(item) {
      this.prnrList = [
        { text: this.$t('lbl.common.conditionSearch.all'), value: '' },
        { text: '*', value: '*' },
      ];
      for (let i = 0; i < this.compList.length; i += 1) {
        if (this.compList[i].value === item.compId) {
          this.prnrList.push(this.compList[i]);
        }
      }
      this.$store.dispatch('getPartnerUseList').then(() => {
        const tmpPrnrList = this.$store.getters.partnerUseList;
        for (let i = 0; i < tmpPrnrList.length; i += 1) {
          const tmpPrnr = tmpPrnrList[i];
          const tmp = { text: tmpPrnr.prnrNm, value: tmpPrnr.prnrId };
          this.prnrList.push(tmp);
        }
      });
    },
    openMiniView(item) {
      // 203728 2021.3.17 Open only view
      let type = 'miniView';
      item.ROWID = 0;
      let indexArrDialog = this.findDialog('miniView_0');
      if (indexArrDialog != null) {
        this.dialogs[indexArrDialog].options.item = item;
        return;
      }
      this.newDialog(item, type) - 1;
    },
    // 2021.11.12 203728 SPKA-243 unlock
    unlockWF(item) {
      // this.$store
      //   .dispatch('setLockUnlocProcessNew', { procId: item.procId, lockWF: false })
      //   .then((res) => {
      //     item.lock = '';
      //   });
    },
    // 2021.11.8 203728 SPKA-243 check lock/unlock
    checkOpenDetail(item, type) {
      // this.$store
      //   .dispatch('getLockProcessNew', { procId: item.procId, lockWF: true })
      //   .then((res) => {
      //     if (res.editUser) {
      //       this.$refs.AlertLockWF.dialog = true;
      //       this.alertMessage = `You can't ${type} workflow - ${item.procNm} because ${res.editUser} is modifying.`;
      //     } else {
      //       this.openProcessWindow(item, type);
      //     }
      //   });
      this.openProcessWindow(item, type);
    },
    openViewProcess(item) {
      const isHistory = true;
      const type = 'View';
      const params = {
        ROWID: item.procId.toString(),
        type: type,
        options: {
          dataValue: item.id,
          id: item.id.toString(),
          isHistory: isHistory,
          versionNo: item.verNo,
        },
      };
      const arrView = {
        item,
        type,
      };
      params.compList = this.compList;
      params.fltrTpCdList = this.fltrTpCdList;
      params.cvtrTpCdList = this.cvtrTpCdList;
      params.aiTpCdList = this.aiTpCdList;
      params.protocolList = this.protocolList;
      const url = `/process/workflowGroupView/${type}/${params.ROWID}`;
      const size = 'width=1800,height=960,left=60,top=20';
      openWindow({
        arrView,
        url: url,
        params,
        size: size,
      });
    },
    openProcessWindow(item, type) {
      let isEdit = false;
      let params = {};
      const arrView = {};
      if (type === 'Edit') {
        isEdit = true;
        params = {
          ROWID: item.id.toString(),
          type: type,
          options: {
            dataValue: item.id,
            id: item.id.toString(),
            isEdit: isEdit,
            versionNo: item.version,
            applyStatus: item.apply_sts,
          },
        };
        arrView.item = item;
        arrView.type = type;
      } else if (type === 'Copy') {
        isEdit = true;
        params = {
          ROWID: item.id.toString(),
          type: type,
          options: {
            dataValue: item.id,
            id: item.id.toString(),
            isCopy: true,
          },
        };
        arrView.item = item;
        arrView.type = type;
      } else {
        item = { id: '0' };
        params = {
          ROWID: '0',
          type: type,
          options: {
            id: '0',
            isEdit: isEdit,
          },
        };
        arrView.item = item;
        arrView.type = type;
      }
      params.compList = this.compList;
      params.fltrTpCdList = this.fltrTpCdList;
      params.cvtrTpCdList = this.cvtrTpCdList;
      params.aiTpCdList = this.aiTpCdList;
      params.protocolList = this.protocolList;
      params.item = item;

      const url = `/process/workflowGroupDetail/${type}/${params.ROWID}`;
      setProcessWindowList(url);
      const size = 'width=1800,height=930,left=60,top=20';
      openWindow({
        arrView,
        url: url,
        params,
        size: size,
        onMessage: async (message) => {
          if (message.includes('move-mapbuilder')) {
            Store.dispatch(
              'mapbuilder/moveToMapBuilder',
              JSON.parse(message.replace('move-mapbuilder', '')),
            ).then(() => {
              // 2022.05.09 213960 SPKA-458 Move to New Tab when moving from Workflow to Map Builder
              this.openMapBuilderWindow(item);
            });
          } else if (message.includes('move-dbmapbuilder')) {
            this.viewFileMoveDBMapBuilder(JSON.parse(message.replace('move-dbmapbuilder', '')));
          }
        },
        onClose: async () => {
          this.searchList();
          // 2021.10.20 203728 refesh map list
          this.getMapList();
          deleteProcessWindow(url);
        },
      });
    },
    openMapBuilderWindow(item) {
      const type = 'MapBuilder';
      const params = {
        ROWID: item.mapId,
        type: type,
        options: {
          dataValue: item,
          id: item.mapId,
        },
      };
      item.id = item.mapId;

      const arrView = {
        item,
        type,
      };
      const url = `/transformation/mapbuilder`;
      openWindow({
        arrView,
        url: url,
        params,
      });
    },
    findIndexItem(arrView, arr, col) {
      let prop = typeof col == 'undefined' ? 'id' : col;
      let index = arr.findIndex((row) => {
        return row.item[prop] === arrView.item[prop] && row.type === arrView.type;
      });
      return index > -1 ? index : null;
    },
    searchList() {
      // 203737 05/11/2021 SPKA-98 issue 53 Fix spiner when search list again
      // 2021.7.20 203728 SPKA-98 SPKA-158 Add condition search
      // 2021.8.30 203728 SPKA-201 add end point condition
      this.isLoading = true;
      const params = {
        srcProcNm: this.srcProcNm,
        srcComponentType: this.srcComponentType,
        srcComponentName: this.srcComponentName,
        srcCommunicationType: this.srcCommunicationType,
        srcCommunicationEndPoint: this.srcCommunicationEndPoint,
        srcAIType: this.srcAIType,
        srcAIEndPoint: this.srcAIEndPoint,
        srcConverterType: this.srcConverterType,
        srcConverterPattern: this.srcConverterPattern,
        srcFilterType: this.srcFilterType,
        srcFilterPattern: this.srcFilterPattern,
        // 2021.12.09 213960 SPKA-324 Remove "Test" and "Live" radio button
        // srcProcTestOrLive: this.srcProcTestOrLive
      };

      // 2021.4.2 203728 Get list workflow new
      this.$store
        .dispatch('getWorkflowGroupList', params)
        .then(() => {
          // 2021.4.19 203728
          this.listData = this.$store.getters.workflowGroupList;
          this.listDataOrigin = this.$store.getters.workflowGroupList;

          this.listData.map((e) => {
            let msgNm = this.messageList.find((r) => r.MAP_PRCS_NO === e.mapId);
            e.msgNm = msgNm ? msgNm.MESSAGENAME : '';
            // e.prnrNm = e.prnrId === '*' ? '*' : this.prnrMap[e.prnrId];
            e.listSender = e.sendList ? e.sendList.split(',') : [];
            e.listRecipient = e.recvList ? e.recvList.split(',') : [];
            e.listMessage = [];
            if (e.mapList) {
              e.mapList = e.mapList.split(',');
              e.listMessage = this.getListMessage(e.mapList);
            }
          });

          this.filter = false;
          this.isLoading = false;
          this.totalCnt = this.listData.length;
          this.caculatePageCount();
          this.changePageSize(this.itemsPerPage);
          // 2021.11.17 213960 Fix bug open edit back to page 1
          if (this.page > this.pageCount) {
            this.changePage(1);
          }
          this.changePage(this.page);
        })
        .catch((ex) => {
          this.isLoading = false;
        });
    },
    search() {
      this.searchList();
    },
    // 203737 05/04/2021 SPKA-88 Issue-46 Fix user_id should be selected company when send the activation JSON
    sendActivate(procId, actCd, compId /*, procComList*/) {
      const params = {
        procId: procId,
        actCd: actCd,
        compId: compId,
        // procComList: procComList, // 2021.4.19 203728 not use
      };
      this.$store
        .dispatch('activateProcessNew', params)
        .then(() => {
          if (params.actCd == 'N') {
            this.$refs.DeactivatedSuccess.dialog = true;
          } else if (params.actCd == 'Y') {
            this.$refs.ActivatedSuccess.dialog = true;
          }
          this.searchList();
        })
        .catch((err) => {
          this.checkDialogInfo = `Exception occured. Reason: ${err}`;
          this.checkDialogColor = 'error';
          this.$refs.AlertProcessSetup.dialog = true;
        });
    },
    // 2021.11.8 203728 SPKA-243 check lock/unlock
    checkBeforeDetele(item, type) {
      this.$store
        .dispatch('getLockProcessNew', { procId: item.procId, lockWF: true })
        .then((res) => {
          if (res.editUser) {
            this.$refs.AlertLockWF.dialog = true;
            this.alertMessage = `You can't ${type} this workflow because ${res.editUser} is modifying.`;
          } else {
            this.deleteItem = item;
            this.$refs.DeleteWorkflow.dialog = true;
          }
        });
    },
    deleteProcess(id, procId, compId, version) {
      // 2021.11.4 203728 not send JSON if it has no apply
      this.isLoading = true;
      const params = {
        id: id,
        actCd: 'D',
        procId: procId,
        compId: compId,
        version: version,
        hash: this.$cookies.get('hash'),
      };
      this.$store
        .dispatch('deleteWorkflowGroup', params)
        .then(() => {
          this.$refs.AlertProcessSetup.dialog = true;
          this.checkDialogColor = 'success';
          this.checkDialogInfo = 'Workflow Group has been deleted successfully.';
          this.isLoading = false;
        })
        .catch((err) => {
          // alert(`Exception occured. Reason: ${err}`);
          this.isLoading = false;
        });
    },
    closeDialog() {
      this.searchList();
    },
    getEDIMsgTypeList() {
      let commMsgSearchItems = {
        header: ['MSG_NM'],
        data: [
          {
            MSG_NM: '',
          },
        ],
      };
      Store.dispatch('common/getCommonMessageList', commMsgSearchItems).then(() => {
        console.log('--------- Finished to process MES ----------');
        for (let i = 0; i < this.CommMsgList.length; i++) {
          let EDIVerObj = {};
          EDIVerObj.text = this.CommMsgList[i].MSG_CD + ' (' + this.CommMsgList[i].MSG_NM + ')';
          EDIVerObj.value = this.CommMsgList[i].MSG_CD;
          this.EDIMesList.push(EDIVerObj);
        }
      });
    },
    getComList(comTpList) {
      const result = [];
      if (comTpList !== undefined && comTpList !== null) {
        for (let i = 0; i < comTpList.length; i += 1) {
          const vResult = [];
          const comVTpList = comTpList[i];
          for (let j = 0; j < comVTpList.length; j += 1) {
            const componentType = comVTpList[j].comTp;
            const height = '40px';
            const resultDtl = {
              icon: '',
              color: '',
              height: height,
            };

            if (componentType === 'COM') {
              resultDtl.icon = 'fa fa-exchange-alt';
              resultDtl.color = 'proc-comm darken-1';
              resultDtl.title = 'Connector';
            } else if (componentType === 'FLT') {
              resultDtl.icon = 'fa fa-filter';
              resultDtl.color = 'proc-filter darken-1';
              resultDtl.title = 'Filter';
            } else if (componentType === 'FLD') {
              resultDtl.icon = 'fa fa-folder';
              resultDtl.color = 'proc-folder darken-1';
              resultDtl.title = 'Folder';
            } else if (componentType === 'SET') {
              resultDtl.icon = 'fa fa-gift';
              resultDtl.color = 'proc-set darken-1';
              resultDtl.title = 'Setup';
            } else if (componentType === 'MAP') {
              resultDtl.icon = 'fa fa-project-diagram';
              resultDtl.color = 'proc-mapper darken-1';
              resultDtl.title = 'Mapper';
            } else if (componentType === 'CVT') {
              resultDtl.icon = 'fa fa-redo';
              resultDtl.color = 'proc-converter darken-1';
              resultDtl.title = 'Converter';
            } else if (componentType === 'ENV') {
              resultDtl.icon = 'fa fa-envelope';
              resultDtl.color = 'proc-envel darken-1';
              resultDtl.title = 'Envelope';
            } else if (componentType === 'DIR') {
              resultDtl.icon = 'fa fa-folder';
              resultDtl.color = 'proc-folder darken-1';
              resultDtl.title = 'Dir';
            }
            vResult.push(resultDtl);
          }
          result.push(vResult);
        }
      }
      // alert(JSON.stringify(result));
      return result;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    getProcComList(item, comTpList) {
      const result = [];
      if (comTpList !== undefined && comTpList !== null) {
        for (let i = 0; i < comTpList.length; i += 1) {
          if (comTpList[i].comTp === 'MAP') {
            for (let j = 0; j < this.messageList.length; j += 1) {
              const message = this.messageList[j];
              if (item.mapId === message.MAP_PRCS_NO) {
                result.push({ comTp: comTpList[i].comTp, comInfo: message });
                break;
              }
            }
          } else {
            result.push({ comTp: comTpList[i].comTp });
          }
        }
      }
      return result;
    },
    //203737 04-02-2021 Show list srm in search list
    showListSrmSender(item, e) {
      let left = e.clientX;
      if (this.overlay === true) {
        this.overlay = false;
      }
      let top = e.clientY + 20;
      $('.tableOverlay').css('top', top);
      $('.tableOverlay').css('left', left);
      this.listSrm = item.listSender;
      this.overlay = true;
    },
    showListSrmRecipient(item, e) {
      let left = e.clientX;
      if (this.overlay === true) {
        this.overlay = false;
      }
      let top = e.clientY + 20;
      $('.tableOverlay').css('top', top);
      $('.tableOverlay').css('left', left);
      this.listSrm = item.listRecipient;
      this.overlay = true;
    },
    showListSrmMessage(item, e) {
      let left = e.clientX;
      if (this.overlay === true) {
        this.overlay = false;
      }
      let top = e.clientY + 20;
      $('.tableOverlay').css('top', top);
      $('.tableOverlay').css('left', left);
      this.listSrm = item.listMessage;
      this.overlay = true;
    },
    closeTbOverlay() {
      this.overlay = false;
    },
    //203737 04/05/2021 Get list message name for multi srm in mapper
    getListMessage(msgNm) {
      let item;
      let listMessage = [];
      for (let i = 0; i < msgNm.length; i++) {
        item = this.mapItem.filter((item) => item.value === msgNm[i]);
        if (item.length !== 0) {
          listMessage.push(item[0].text);
        }
      }
      return listMessage;
    },
    getMessage(msgNm) {
      let item = this.mapList.filter((item) => item.MAP_PRCS_NO === msgNm);
      if (item.length !== 0) {
        return item[0].text;
      }
      return '';
    },
    changePage(pageNo, clear = true) {
      this.page = pageNo;
      // 2021.9.9 203728 SPKA-199 Clear select row
      if (clear) {
        this.listFrozen.map((e) => {
          $('#' + e + this.rowCurrentClick).removeClass('custom-row-click-v-table');
        });
      }
      let startIndex = this.itemsPerPage * (pageNo - 1);
      let endIndex = this.totalCnt;
      if (this.itemsPerPage < this.totalCnt) {
        endIndex = this.itemsPerPage * pageNo;
        if (endIndex > this.totalCnt) {
          endIndex = this.totalCnt;
        }
      }
      // 2021.11.17 213960 SPKA-248 issue 168 Modify page function of Workflow search screen
      if (!this.isFilter) {
        this.$store.commit('SET_STORE_WORKFLOW_GROUP_LIST_PAGING', {
          startIndex: startIndex,
          endIndex: endIndex,
        });
        this.listData = this.$store.getters.workflowGroupList;
      } else {
        this.$store.commit('SET_STORE_WORKFLOW_GROUP_LIST_FILTER', {
          filter: this.searchBy,
          strSearch: this.searchByTxt,
        });
        this.$store.commit('SET_STORE_WORKFLOW_GROUP_LIST_FILTER_PAGING', {
          startIndex: startIndex,
          endIndex: endIndex,
        });
        this.listData = this.$store.getters.workflowGroupList;
      }
    },
    changePageSize(pageSize) {
      if (!this.isFilter) {
        this.$store.commit('SET_STORE_WORKFLOW_GROUP_LIST_PAGING', {
          startIndex: 0,
          endIndex: pageSize,
        });
      } else {
        this.$store.commit('SET_STORE_WORKFLOW_GROUP_LIST_FILTER_PAGING', {
          startIndex: 0,
          endIndex: pageSize,
        });
      }
      this.listData = this.$store.getters.workflowGroupList;
    },
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
      this.changePage(this.page);
    },
    caculatePageCount() {
      if (this.totalCnt % this.itemsPerPage === 0) {
        this.pageCount = this.totalCnt / this.itemsPerPage;
      } else {
        this.pageCount = Math.floor(this.totalCnt / this.itemsPerPage) + 1;
      }
    },
    onFilterProcessList() {
      // 2021.9.9 203728 SPKA-199 Clear select row
      this.$refs.process_list_table.clearCurrentRow();
      this.rowCurrentClick = -1;
      this.page = 1;
      this.$store.commit('SET_STORE_WORKFLOW_GROUP_LIST_FILTER', {
        filter: this.searchBy,
        strSearch: this.searchByTxt,
      });
      this.listData = this.$store.getters.workflowGroupList;
      this.totalCnt = this.listData.length;
      this.caculatePageCount();
      this.isFilter = true;
      this.changePage(1);
    },
    sortChange(data) {
      let keys = Object.keys(data);
      for (let i = 0; i < keys.length; i++) {
        let col = keys[i];
        let sort = data[col];
        if (sort) {
          this.$store.commit('SET_STORE_WORKFLOW_GROUP_LIST_SORT', { col, sort });
          this.listData = this.$store.getters.workflowGroupList;
          this.setVisibilitySortIcon(col, sort);
          // 2021.9.9 203728 SPKA-199 Change background when hover,click row in v-table
          // Clear current row by library
          this.$refs.process_list_table.clearCurrentRow();
          // Clear row select of previous sort
          this.columns.map((e) => {
            $('#' + e.field + this.rowCurrentClick).removeClass('custom-row-click-v-table');
          });
          let index = this.listData.findIndex((e) => e.procId === this.rowKey);
          if (index > -1) {
            // Change row select of current sort
            this.rowCurrentClick = index;
            this.columns.map((e) => {
              $('#' + e.field + index).addClass('custom-row-click-v-table');
            });
          }
        }
      }
    },
    setIndex(id) {
      return getIndexItem(id, this.listDataOrigin);
    },
    setVisibilitySortIcon(colName, sort) {
      let classVisible = `.repo-list-table .v-table-header .${colName} .v-table-sort-icon`;
      $(classVisible).css('visibility', 'visible');
      if (sort === 'reset') {
        $(classVisible).removeAttr('style');
      }
    },
  },
  updated: function() {
    let self = this;
    let arrClassMinus = ['.page-control-bg'];
    let arrClassPlus = [];

    if (this.isCreated) {
      // Minus height border 2px
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 - 2;
      if (self.$refs.process_list_table != undefined) {
        self.$refs.process_list_table.initView();
        self.$refs.process_list_table.scrollControl();
        self.$refs.process_list_table.resize();
      }
      self.isCreated = false;
    }

    $(window).resize(function(event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 - 2;
      if (self.$refs.process_list_table != undefined) {
        self.$refs.process_list_table.initView();
        self.$refs.process_list_table.scrollControl();
        self.$refs.process_list_table.resize();
      }
    });
  },
  mounted() {
    $('body').click((event) => {
      this.closeTbOverlay();
    });
  },
};
</script>
